module.exports = __webpack_public_path__ + "static/media/chevronTourLeft.7e0d9020.svg";